var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureBluee064F22Fbdd783A20B005F2E92Ecc6D4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1347,
    height: 898,
    viewBox: "0 0 1347 898",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M840.065 927.494L27.9277 114.466C-3.11249 83.3876 -14.0451 39.8604 -4.90881 0H-849V1418L1347 1435L840.065 927.494Z",
    fill: "#001864"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureBluee064F22Fbdd783A20B005F2E92Ecc6D4);
export default __webpack_public_path__ + "static/media/figure-blue.e064f22fbdd783a20b005f2e92ecc6d4.e064f22fbdd783a20b005f2e92ecc6d4.svg";
export { ForwardRef as ReactComponent };